// lib/analyticsEvents.js
import { logEvent } from './firebase';

export const ANALYTICS_EVENTS = {
  Login: 'Login',
  SignUp: 'SignUp',
  CreatePost: 'CreatePost',
  PersonalProfile: 'PersonalProfile',
  Network: 'Network',
  ManageConnection: 'ManageConnection',
  Invitations: 'Invitations',
  PeopleYouMayKnow: 'PeopleYouMayKnow',
  FollowingFollowerList: 'FollowingFollowerList',
  TeamList: 'TeamList',
  TeamDetail: 'TeamDetail',
  ManageTeam: 'ManageTeam',
  Chat: 'Chat',
  ChatList: 'ChatList',
  Search: 'Search',
  Calendar: 'Calendar',
  ScheduleMeeting: 'ScheduleMeeting',
  JoinMeeting: 'JoinMeeting',
  Meeting: 'Meeting',
  UpcomingMeeting: 'UpcomingMeeting',
  AppointmentList: 'AppointmentList',
  CreateAppointment: 'CreateAppointment',
  BookAppointment: 'BookAppointment',
  MyDisk: 'MyDisk',
  MyDiskDetail: 'MyDiskDetail',
  TeamDisk: 'TeamDisk',
  ShareDisk: 'ShareDisk',
  Notifications: 'Notifications',
  PublicProfile: 'PublicProfile',
  SuggestedJobs: 'SuggestedJobs',
  MyJobs: 'MyJobs',
  AppliedJobs: 'AppliedJobs',
  JobPreferences: 'JobPreferences',
  TrackJob: 'TrackJob',
  JobDetail: 'JobDetail',
  SavedJobs: 'SavedJobs',
  ManagePages: 'ManagePages',
  CreateCompany: 'CreateCompany',
  CompanyDetail: 'CompanyDetail',
  MyArticles: 'MyArticles',
  ArticleDetails: 'ArticleDetails',
  MyEvents: 'MyEvents',
  CreateEvent: 'CreateEvent',
  EventDashboard: 'EventDashboard',
  EventDetail: 'EventDetail',
  HelpSupport: 'HelpSupport',
  Settings: 'Settings',
  AccountSettings: 'AccountSettings',
  NotificationSettings: 'NotificationSettings',
  SubscriptionList: 'SubscriptionList',
  Integrations: 'Integrations',
  AudienceAndVisibility: 'AudienceAndVisibility',
  Logout: 'Logout',
  ChangeLanguage: 'ChangeLanguage',
  ReelsView: 'ReelsView',
  SharePost: 'SharePost',
  AgreePost: 'AgreePost',
  DisagreePost: 'DisagreePost',
  CommentPost: 'CommentPost',
  EditPost: 'EditPost',
  SentInvitation: 'SentInvitation',
  MyCircleScreen: 'MyCircleScreen',
  SuggestionScreen: 'SuggestionScreen',
  ProfileViewScreen: 'ProfileViewScreen',
  BlockedNetworkScreen: 'BlockedNetworkScreen',
  EditMeeting: 'EditMeeting',
  GenerateNewMeeting: 'GenerateNewMeeting',
  TeamInvite: 'TeamInvite',
  TeamPendingPost: 'TeamPendingPost',
  TeamBlockedUsers: 'TeamBlockedUsers',
  CreateTeam: 'CreateTeam',
  DiskFilePreview: 'DiskFilePreview',
  CreateGroupChat: 'CreateGroupChat',
  GroupChat: 'GroupChat',
  TeamChat: 'TeamChat',
  PublicAppointment: 'PublicAppointment',
  GiveTestimonial: 'GiveTestimonial',
  AskTestimonial: 'AskTestimonial',
  CreateJob: 'CreateJob',
  CreateService: 'CreateService',
  EditService: 'EditService',
  AddExperience: 'AddExperience',
  AddSkill: 'AddSkill',
  AddSchool: 'AddSchool',
  AddCollege: 'AddCollege',
  AddMilestone: 'AddMilestone',
  AddCertificateAndAward: 'AddCertificateAndAward',
  ProfileSetting: 'ProfileSetting',
};

export const trackEvent = (eventName, userSlug, extraData = {}) => {
  if (!eventName || !userSlug) return;

  const payload = {
    UserSlug: userSlug,
    ...extraData,
  };

  logEvent(eventName, payload);
};
